(function ClientOpportunityBulkUpdateProgress($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		var interval_id = null;

		Adzuki.onload('ClientOpportunities/bulkUpdateProgress', function onload()
		{
			// handle refresh button
			$('.so-bulk-update-refresh').on('click', function _refreshProgress(e) {
				e.preventDefault();
				_checkProgress();
			});

			// check for the progress on the bulk update
			interval_id = window.setInterval(_checkProgress, 2000);
		});

		function _checkProgress()
		{
			var $progress_bar = $('#so-bulk-update-progress-bar');
			var url           = '/ClientOpportunities/bulkUpdateCheckProgress/' + $progress_bar.data('id');

			Adzuki.Ajax.get(url).then(function success(response) {
				var percent = null;

				if (response.percent_complete) {
					percent = response.percent_complete + '%';

					$progress_bar.css('width', percent);

					$('.so-bulk-update-percent').html(percent);

					if (parseInt(response.percent_complete) === 100) {
						if (interval_id) {
							window.clearInterval(interval_id);
						}

						$progress_bar.removeClass('progress-bar-striped active');

						// change text and setup a new click handler
						$('.so-bulk-update-refresh').text('Ok, got it');
						$('.so-bulk-update-refresh').off().on('click', function _bulkUpdateDone(e) {
							e.preventDefault();

							window.document.location = Adzuki.erez_url + Adzuki.base_uri + '/ClientOpportunities/bulkUpdateFinish';
						});
					}
				}
			});
		}
	});
}(jQuery, window.Adzuki || {}));
